import { ChangeDetectionStrategy, Component, signal } from "@angular/core"
import { MatButtonModule } from "@angular/material/button"
import { MatIconModule } from "@angular/material/icon"
import { MatTooltipModule } from "@angular/material/tooltip"
import { ChatPanelComponent } from "../chat-panel/chat-panel.component"

@Component({
  selector: "app-chat-widget",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatIconModule, MatTooltipModule, ChatPanelComponent],
  template: `
    @if (isOpen()) {
      <app-chat-panel (close)="isOpen.set(false)" />
    }
    <button
      mat-fab
      color="primary"
      class="chat-fab"
      [matTooltip]="isOpen() ? 'Close advisor' : 'Open AI advisor'"
      (click)="isOpen.set(!isOpen())"
    >
      <mat-icon>{{ isOpen() ? "close" : "smart_toy" }}</mat-icon>
    </button>
  `,
  styles: [
    `
      :host {
        position: fixed;
        bottom: 24px;
        right: 24px;
        z-index: 1000;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 12px;
      }
      .chat-fab {
        flex-shrink: 0;
      }
    `,
  ],
})
export class ChatWidgetComponent {
  protected readonly isOpen = signal(false)
}
